// PracticeReview의 사례개념화 양식에서 lens에 따라 사용하는 항목입니다.
// CaseConceptualization.js의 필드 정의를 기준으로 하며 helper는 문장형으로 제공합니다.
export const fields = [
    {
        key: 'presenting',
        label: '주 호소 / 의뢰 사유',
        required: true,
        lens: '공통',
        helper: '내담자가 어떤 어려움으로 상담을 찾았는지, 어떻게 의뢰되었는지 적어주세요.',
    },
    {
        key: 'history',
        label: '배경·발달·관계사(간략)',
        lens: 'SCORS / PBT',
        helper: '가족과 성장 과정, 주요 관계 경험 중 현재의 어려움과 관련된 내용을 적어주세요.',
    },
    {
        key: 'relationship',
        label: '주요 관계 상호작용 패턴(구체 일화 1~2개)',
        lens: 'SCORS 핵심',
        helper: '관계에서 반복되는 상호작용을 실제 장면 한두 가지와 함께 구체적으로 적어주세요.',
    },
    {
        key: 'affect',
        label: '정서 경험과 조절 양상',
        lens: 'SCORS / PBT',
        helper: '내담자가 어떤 감정을 경험하고, 그 감정을 어떻게 다루는지 적어주세요.',
    },
    {
        key: 'function',
        label: '증상·어려움이 맞물리는 상황·기능',
        lens: 'PBT/EEMM 핵심',
        helper: '증상이나 어려움이 언제, 어떤 상황에서 심해지거나 유지되는지 적어주세요.',
    },
    {
        key: 'changetalk',
        label: '변화에 대한 내담자의 언어(실제 표현)',
        lens: 'MI 핵심',
        helper: '변화를 바라는 마음이나 망설임이 드러나는 내담자의 실제 표현을 적어주세요.',
    },
    {
        key: 'risk',
        label: '위험 관련 신호',
        required: true,
        lens: 'Stage 0 플래그',
        helper: "자·타해, 학대·방임, 급성 위기와 관련된 언급을 적어주세요. 확인된 신호가 없으면 '없음', 아직 확인하지 못했다면 '추가 확인 필요'라고 적어주세요.",
    },
];
